import {StoreIconType, StoreItemCategory} from '../../../../../shared/entity_datas/StoreEnums'
import {BaseStoreItem} from '../../../../../shared/store/BaseStoreItem'
import {StoreItemController} from '../../../../../shared/store/StoreItemController'
import {CA} from '../../analytics/Analytics'
import {ProfileEditAjaxEndPoints} from '../../profile/ProfileEditAjaxEndPoints'
import {Sound} from '../../Sound'
import {createDivIn, createImgIn, createLinkIn, setElementInnerHTML, setElementOnClick} from '../../ui_utils/DomUtils'
import {UIPopupController} from '../../ui_popup/UIPopupController'
import {LobbyImage} from '@colonist/types'
import {notificationController} from '../../EntryShared'
import {clientI18n} from '../../ClientI18n'
import {getNestedTranslation, TranslationObject} from '@colonist/i18n'
import {ClientUserState} from '../../ClientUserState'
import {navigateToPage} from '../../ui_utils/ClientUtils'

export class UIProfileEditAvatarController {
    private static readonly avatarStoreLink = '/store#avatars'

    private readonly iconsContainer: HTMLDivElement
    private readonly iconsGrid: HTMLDivElement
    private selectedIcon: HTMLImageElement
    private readonly selectIconAction: () => void

    constructor(iconsContainer: HTMLDivElement, iconsGrid: HTMLDivElement, selectIconAction: () => void) {
        this.iconsContainer = iconsContainer
        this.iconsGrid = iconsGrid
        this.selectIconAction = selectIconAction

        ClientUserState.registerChangeListener((userState) => {
            if(userState == undefined) return
            this.displayIcons(userState.items.icons, userState.icon)
        })
    }

    private updateSelectedIcon(newIconImage: HTMLImageElement) {
        if(this.selectedIcon !== undefined) this.selectedIcon.classList.remove('active')
        this.selectedIcon = newIconImage
        this.selectedIcon.classList.add('active')
    }

    private displayIcons(ownedIcons: BaseStoreItem[], currentIcon: LobbyImage) {
        const allIcons = StoreItemController.getItemsInCategory(StoreItemCategory.Icon, false)
        setElementInnerHTML(this.iconsGrid, {key: 'strings:colonistCommon.utils.emptyString'})

        this.showStoreLinkElement()

        for(const icon of allIcons) {
            const ownsIcon = ownedIcons.some((ownedIcon) => ownedIcon.type == icon.type)
            const iconImgClassName = ownsIcon ? 'owned' : 'header_profile_color_transparent'
            const iconImgElement = createImgIn(this.iconsGrid, icon.image, iconImgClassName)

            if(ownsIcon) {
                if(icon.image == currentIcon) this.updateSelectedIcon(iconImgElement)

                setElementOnClick(iconImgElement, () => {
                    Sound.playSound(Sound.SoundType.Click)
                    CA.sendGoogleAnalyticsEvent(CA.Category.HeaderProfile, CA.Label.HeaderProfileClickedChangeIcon)
                    void this.updateIcon(icon.type as StoreIconType)

                    const primaryMessage: TranslationObject = {key: 'strings:homePage.header.avatarSelector.avatarChanged'}
                    const nestedTranslation = getNestedTranslation(primaryMessage, {icon: icon.name})

                    notificationController?.showNotification(icon.image, nestedTranslation)
                    this.selectIconAction()
                })
                continue
            }
            setElementOnClick(iconImgElement, () => {
                const iconName = clientI18n.t(icon.name.key, icon.name.options)
                const body: TranslationObject = {key: 'strings:homePage.header.storePurchaseIconPrompt', options: {iconName: iconName}}
                UIPopupController.create({key: 'strings:homePage.header.avatarSelector.youDoNotOwnThisItem'}, body, () => {
                    navigateToPage(UIProfileEditAvatarController.avatarStoreLink, true, true)
                }, () => undefined, true)
            })
        }
    }

    private showStoreLinkElement() {
        const storeLinkElementClass = 'header_profile_selector_noicons'
        const storeLinkElements = this.iconsContainer.getElementsByClassName(storeLinkElementClass)
        for(const storeLinkElement of storeLinkElements) {
            storeLinkElement.remove()
        }

        const container = createDivIn(this.iconsContainer, storeLinkElementClass)
        createLinkIn(container, UIProfileEditAvatarController.avatarStoreLink, {key: 'strings:homePage.header.avatarSelector.getMoreAvatars'}, '', '', true)
    }

    // eslint-disable-next-line class-methods-use-this
    async updateIcon(icon: StoreIconType) {
        await ProfileEditAjaxEndPoints.updateIcon(icon)
    }
}
